var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signin container box"},[_c('h2',[_vm._v("電話番号を入力してください")]),_vm._v(" "),_c('p',{staticClass:"note"},[_vm._v("\n    セキュリティ強化と不正防止のため、電話番号認証によるログインをお願いしています。SMS(ショートメッセージ)が受けとれる日本の電話番号を下のフォームに入力してください。\n  ")]),_vm._v(" "),_c('tel',{on:{"finishAuth":_vm.finishSignin}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04acf756","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sign.vue
// module id = null
// module chunks = 